<div class="modal-header">
  <h5 class="modal-title">Sign Consent Form</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body" style="height: 70vh; padding: 0;">
  <iframe
    *ngIf="signingUrl"
    [src]="signingUrl | safeUrl"
    width="100%"
    height="100%"
    frameborder="0"
    allowfullscreen
    style="min-height: 60vh; border: none; display: block;"
  ></iframe>
  <div *ngIf="!signingUrl" class="text-center p-4">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p>Loading signature form...</p>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary close-button" (click)="activeModal.dismiss()">
    Close
  </button>
</div> 